<h2 mat-dialog-title>
  Referral Details
</h2>

<mat-dialog-content [formGroup]="form">
  <!-- Banner if read-only -->
  <div *ngIf="isReadOnly" class="banner-closed">
    <mat-icon>lock</mat-icon>
    This referral is already closed and cannot be modified.
  </div>

  <!-- READ-ONLY DETAILS (unchanged) -->
  <section class="details" *ngIf="referral as r">
    <h3>Referral Details</h3>

    <div class="kv">
      <div class="key">Referral Type</div>
      <div class="val">{{ r.referralType || data.sourceType }}</div>
    </div>

    <div class="row checks" *ngIf="r.review as rev">
      <mat-checkbox [checked]="rev.spokeWithMember" disabled>Spoke With Member</mat-checkbox>
      <mat-checkbox [checked]="rev.leftMessage" disabled>Left Message</mat-checkbox>
      <mat-checkbox [checked]="rev.sentLetter" disabled>Sent Letter</mat-checkbox>
    </div>

    <div class="kv" *ngIf="r.review?.appointmentDate">
      <div class="key">Appointment</div>
      <div class="val">{{ r.review?.appointmentDate | date:'MMM d, y, h:mm a' }}</div>
    </div>

    <mat-divider class="mb"></mat-divider>
  </section>

  <!-- FORM CONTROLS (auto-disabled if isReadOnly) -->
  <div class="row">
    <mat-checkbox formControlName="closeReferral">Close this referral</mat-checkbox>
  </div>

  <mat-form-field appearance="fill" class="full">
    <mat-label>DCO Note</mat-label>
    <mat-select formControlName="dcoNote">
      <mat-option *ngFor="let item of dcoNotes" [value]="item.name">
        {{ item.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Close</button>
  <!-- Hide save button if read-only -->
  <button *ngIf="!isReadOnly" mat-flat-button color="primary" (click)="save()" [disabled]="saving">
    Save
  </button>
</mat-dialog-actions>
